import { Link, useNavigate } from 'react-router-dom';
import BackArrowIcon from '../Icons/BackArrowIcon';
import { ReactNode, useEffect, useState } from 'react';
import DatePickerInput from './DatePicker';
import DateRangePickerInput from './DateRangePickerInput';
import moment from 'moment';
import { RootState } from '@/redux/store';
import { useSelector } from 'react-redux';

interface IMainHeadingProps {
  buttonText?: string;
  buttonLink?: string;
  stateData?: unknown;
  buttonIcon?: ReactNode;
  clickHandler?: () => void;
  showbBackButton?: boolean;
  title: string;
  sites?: unknown;
  office?: unknown;
  singleDateChangeHandler?: ((date: Date | null) => void) | null;
  showDefaultDate?: boolean;
  pageState?: { sortBySingleDate?: string | string[]; sortByDate?: string[] };
  pickerType?: string;
  dateChangeHandler?: (date: Date[]) => void;
  selectedDate?: string;
  isNotification?: boolean;
}
const MainHeading = ({
  buttonText,
  buttonLink,
  stateData,
  buttonIcon,
  clickHandler,
  showbBackButton,
  title,
  singleDateChangeHandler,
  pageState,
  pickerType,
  dateChangeHandler,
  showDefaultDate,
  selectedDate,
  isNotification,
}: IMainHeadingProps) => {
  const navigate = useNavigate();
  const filterDetails = useSelector(
    (state: RootState) => state.user.filtersStates,
  );
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const [resetYear, setResetYear] = useState<string[]>(
    filterDetails?.sortByDate,
  );
  useEffect(() => {
    const sourceDate = pageState?.sortByDate || filterDetails?.sortByDate;
    setResetYear(
      !sourceDate || sourceDate?.length == 0
        ? [
            moment(moment().subtract(30, 'days').toDate()).format('YYYY-MM-DD'),
            moment(moment().toDate()).format('YYYY-MM-DD'),
          ]
        : sourceDate,
    );
  }, [filterDetails?.sortByDate, pageState?.sortByDate]);
  return (
    <>
      <div className="content-head mb-5 d-flex align-items-start justify-content-between gap-2 flex-wrap">
        <div className="d-flex gap-3">
          {showbBackButton && (
            <button className="btn back-arrow " onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
          )}
          <h1 className="mb-0">{title}</h1>
        </div>
        <div className="d-flex align-items-center gap-3 flex-wrap">
          {singleDateChangeHandler && (
            <DatePickerInput
              pageState={pageState}
              pickerType={pickerType}
              singleDateChangeHandler={singleDateChangeHandler}
              selectedDate={selectedDate}
            />
          )}
          {dateChangeHandler && (
            <DateRangePickerInput
              dateChangeHandler={dateChangeHandler}
              showDefaultDate={showDefaultDate}
              resetYear={resetYear}
              setResetYear={setResetYear}
            />
          )}
          {buttonLink && (
            <Link
              to={buttonLink}
              state={stateData}
              className="btn btn-outline-primary px-5"
            >
              <span>{buttonIcon}</span>
              {buttonText}
            </Link>
          )}
          {clickHandler && isNotification && userDetails?.type == 1 ? (
            <button
              onClick={clickHandler}
              className="btn btn-outline-primary px-5"
            >
              <span>{buttonIcon}</span>
              {buttonText}
            </button>
          ) : !isNotification && clickHandler ? (
            <button
              onClick={clickHandler}
              className="btn btn-outline-primary px-5"
            >
              <span>{buttonIcon}</span>
              {buttonText}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};
export default MainHeading;
